import React from 'react';

const DownloadIcon = () => (
  <svg className="icon icon-download" width="9px" height="11px" viewBox="0 0 9 11">
    <g id="Blinds.com" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Measure-and-Installation-/-Quote-/-Blank"
        className="group-1"
        transform="translate(-533.000000, -488.000000)"
        fill="#009FD4"
      >
        <path
          d="M542,491.882353 L539.428571,491.882353 L539.428571,488 L535.571429,488 L535.571429,491.882353 L533,491.882353 L537.5,496.411765 L542,491.882353 L542,491.882353 Z M533,497.705882 L533,499 L542,499 L542,497.705882 L533,497.705882 L533,497.705882 Z"
          id="Shape"
          className="shape-1"
        />
      </g>
    </g>
  </svg>
);

export default DownloadIcon;
